import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  listGenerationSites,
  listPlantUnits,
  updateGenerationSite,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/** 発電所 (サイト) の更新 mutation (楽観ロック)。成功したら一覧を最新化する。 */
export function useUpdateGenerationSite(): InvalidatingMutationResultFor<
  typeof updateGenerationSite
> {
  return useInvalidatingMutation(updateGenerationSite, [
    createConnectQueryKey({
      schema: listGenerationSites,
      cardinality: 'finite',
    }),
    // エリア不一致の印は発電所のエリアから決まるので、エリアを変えたらユニットの一覧も取り直す
    createConnectQueryKey({ schema: listPlantUnits, cardinality: 'finite' }),
  ])
}
